// extracted by mini-css-extract-plugin
export default {"popover_bg":"popover_popover_bg__jD63v","tb_wrapper":"popover_tb_wrapper__3fCZr","visible_tb":"popover_visible_tb__OLd3H"};